import { useAuthenticatedUser } from "@/hooks/use-authenticated-user";
import { Feature } from "@/types/user";

export function useFeatureAccess() {
  const userData = useAuthenticatedUser();

  const hasAccess = (requiredFeature?: Feature) => {
    if (!requiredFeature) return true;
    return userData.organization.features.includes(requiredFeature) || false;
  };

  return {
    hasAccess,
  };
}
